export const amountUnits = [
  {
    key: 'kilograms',
    name: 'kg',
  },
  {
    key: 'grams',
    name: 'g',
  },
  {
    key: 'liters',
    name: 'l',
  },
  {
    key: 'milliliters',
    name: 'ml',
  },
  {
    key: 'ounces',
    name: 'oz',
  },
  {
    key: 'pounds',
    name: 'lbs',
  },
  {
    key: 'fluidOunces',
    name: 'fl oz',
  },
  {
    key: 'gallons',
    name: 'gal',
  },
];
